import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common'
import { provideHttpClient, withXhr } from '@angular/common/http'
import localeGb from '@angular/common/locales/en-GB'
import { importProvidersFrom } from '@angular/core'
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core'
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field'
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip'
import { DateFnsAdapter, MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter'
import { bootstrapApplication } from '@angular/platform-browser'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideRouter, TitleStrategy } from '@angular/router'
import { provideTranslateService } from '@ngx-translate/core'
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader'
import { enGB } from 'date-fns/locale'
import { CustomDateFnsModule } from '@app/custom-date.module'
import { DurationPipe } from '@app/duration.pipe'
import { SUPPORT_ENVIRONMENTS } from '@app/multi-environment/support-environment'
import { AppQueryClient, provideAppQueryClient } from '@app/query'
import { SupportLinkResolver } from '@app/multi-environment/support-link.resolver'
import { atlasConversationLink, CONVERSATION_LINK } from '@app/support/conversations/conversation-link'
import { AppComponent } from './app/app.component'
import { routes } from './app/app.routes'
import { AtlasSupportLinkResolver } from './app/atlas-support-link.resolver'
import { AtlasTitleStrategy } from './app/atlas-title-strategy'
import { ATLAS_ENVIRONMENTS } from './app/environments'

registerLocaleData(localeGb)

/**
 * Zone-based rather than zoneless, unlike the standalone ledger Atlas used to be: the support
 * components it now hosts are the main UI's, which are written against zone change detection.
 * Running the two apps on different strategies is how you get a screen that works in one and not
 * the other.
 */
bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    { provide: TitleStrategy, useClass: AtlasTitleStrategy },
    provideAnimationsAsync(),
    provideHttpClient(withXhr()),
    provideAppQueryClient(new AppQueryClient()),
    { provide: SUPPORT_ENVIRONMENTS, useValue: ATLAS_ENVIRONMENTS },
    { provide: SupportLinkResolver, useClass: AtlasSupportLinkResolver },
    { provide: CONVERSATION_LINK, useValue: atlasConversationLink },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    { provide: MAT_DATE_LOCALE, useValue: enGB },
    { provide: DateAdapter, useClass: DateFnsAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS },
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { showDelay: 500 } },
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'd MMM y HH:mm' } },
    provideTranslateService({
      fallbackLang: 'en_US',
      loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    }),
    importProvidersFrom(CustomDateFnsModule),
    DurationPipe,
  ],
}).catch((error) => console.error(error))
